<div class="notification-menu-container" (scroll)="onScroll($event)">
    <ng-container *ngIf="items.length > 0; else noData">
        <div class="notification-info-brief">
            Total alertas últimas 24 horas <span>{{notificationsAmount}}</span>
        </div>
        <div class="notification-info" *ngFor="let item of items; let i = index">
            <div *ngIf="item['state']" class="status-indicator"></div>
            <sit-icon [icon]="item['icon'] || Icon.alert_y" [sizeClass]="'icon-size-40'" class="d-flex"></sit-icon>

            <div class="notification-body">
                <h5 class="notification-title">{{ item['title'] }}</h5>
                <h5 class="notification-title">{{ item['subtitle'] }}</h5>
                <p class="notification-status">{{ item['statusValue'] }}</p>
                <div class="notification-footer-info">
                    <div class="d-flex gap-8-px align-items-center">
                        <sit-icon [icon]="Icon.calendar_beige" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                        <span>{{ item['detectedDate'] | date:'dd/MM/yyyy - hh:mm' }}</span>
                    </div>
                    <div class="d-flex gap-8-px align-items-center">
                        <sit-icon [icon]="Icon.location_beige" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                        <span>{{ item['name'] }}</span>
                    </div>
                    <div class="d-flex gap-8-px align-items-center" *ngIf="item['stationName']">
                        <sit-icon [icon]="Icon.location_beige" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                        <span>{{ item['stationName'] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Spinner de carga -->
        <div class="spinner-container" *ngIf="loading">
            <div title="1">
                <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
                    viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                    <path fill="#000"
                        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                        <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
                            to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                    </path>
                </svg>
            </div> Cargando más elementos...
        </div>
    </ng-container>
    <ng-template #noData>
        <div class="no-data-container">
            <sit-icon [icon]="Icon.HeaderNotificationsIcon" [sizeClass]="'icon-size-96'"
                alt="icono de notificaciones faltantes"> </sit-icon>
            <p>Tus notificaciones se mostrarán aquí</p>
        </div>
    </ng-template>
</div>
